// eslint-disable-next-line deprecate/import
import Link from 'next/link';

import type { MouseEventHandler } from 'react';

import classNames from 'classnames';

import LinkIcon from '@uikit/icons/Link';

import { useAuth } from '@shared/common/providers/AuthProvider';
import { tokensInfo } from '@shared/constants/wallets';

import { Tooltip } from '@ui/uikit/components/common/Tooltip';
import { Typography } from '@ui/uikit/components/common/Typography';
import { Reload } from '@ui/uikit/components/icons/mono/Reload';

import { usePredictionEntries } from '../../../../../api/usePredictionRounds/usePredictionEntries';

interface MyRewardCellProps {
  value?: number;
  formattedValue?: string;
  isClaimed?: boolean;
}

export const MyRewardCell = ({ value, isClaimed, formattedValue }: MyRewardCellProps) => {
  const { userEvmWallet } = useAuth();
  const userWalletAddress = userEvmWallet?.attributes?.address;

  const { refetch, isFetching } = usePredictionEntries();

  const onClickLink: MouseEventHandler<HTMLAnchorElement> = (e) => {
    e.stopPropagation();
  };

  const onClickReload: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();

    if (isClaimed) {
      return;
    }

    refetch();
  };

  if (!isClaimed) {
    return (
      <div className="flex gap-4 self-start items-center">
        <Typography color="tertiary" variant="caption-s">
          Calculating...
        </Typography>
        <Tooltip
          side="top"
          trigger={
            <button
              type="button"
              data-skeleton-target="base"
              className={classNames('msq-btn msq-btn-secondary msq-btn-icon-sm', {
                'msq-btn-loading': isFetching,
              })}
              onClick={onClickReload}
            >
              <Reload className="icon-xs text-base-text-primary" />
            </button>
          }
          caption="Reload"
        />
      </div>
    );
  }

  if (value && value > 0) {
    const usdtToken = tokensInfo.USDT;

    return (
      <div className="flex gap-2 self-start items-center">
        {formattedValue}
        {
          <Tooltip
            side="top"
            trigger={
              <Link
                onClick={onClickLink}
                href={`https://bscscan.com/token/${usdtToken.contractsAddresses.token}?a=${userWalletAddress}`}
                target="_blank"
                className="msq-btn msq-btn-secondary msq-btn-icon-sm"
              >
                <LinkIcon className="icon-xs text-base-text-primary" />
              </Link>
            }
            caption="View Transaction"
          />
        }
      </div>
    );
  }

  return (
    <div className="self-start items-center xl-msq:pt-1.5">
      <Typography variant="caption-s" color="tertiary">
        No Reward
      </Typography>
    </div>
  );
};
